import React, { useEffect, useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Button } from '../../../Elements';
import clsx from 'clsx';
import { Image } from 'components/UI/Media';
import { useScrollInfo } from 'utils/hooks/useScrollInfo';
import { useMediaQuery } from 'utils/hooks/useMediaQuery';
import './index.css';

const useCenterContent = (width) => {
  const [margin, setMargin] = useState(0);

  useEffect(() => {
    const listener = () => {
      const dim = (window.innerWidth - width) / 2;
      setMargin(dim > 16 ? dim : 16);
    };
    listener();
    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);

  return margin;
};
const DEFAULT_COLOR = 'gray';

export const SliderSelect = ({
  label,
  type,
  color,
  helperText,
  value,
  values,
  onChange,
  filteredOptions,
  select,
  unselect,
}) => {
  const isTabletOrLower = useMediaQuery('md');
  const marginToCenter = useCenterContent(308);
  const [scroll, setRef, ref] = useScrollInfo();

  const overflow = ref.current?.scrollWidth > ref.current?.clientWidth;

  const handleOnClick = (direction) => {
    if (typeof window !== 'undefined') {
      const scrollableTabs = ref.current;
      if (scrollableTabs) {
        const elementWidth = scrollableTabs.scrollWidth;
        if (direction === 'left') {
          scrollableTabs.scrollTo({
            top: 0,
            left: -elementWidth,
            behavior: 'smooth',
          });
        } else if (direction === 'right') {
          scrollableTabs.scrollTo({
            top: 0,
            left: elementWidth,
            behavior: 'smooth',
          });
        }
      }
    }
  };

  return (
    <>
      <div className={'px-8'}>
        <Label
          {...label}
          align='text-center'
          size='3xl'
          color={{ classname: 'gray-800' }}
        />
      </div>

      <div
        className={
          'mt-8 flex flex-1 flex-col items-center justify-center w-full'
        }
      >
        <div
          id={'slider-select'}
          className={clsx('flex', 'w-full justify-around', 'relative')}
        >
          <div
            ref={setRef}
            className={'flex overflow-auto no-scrollbar'}
            style={{
              paddingLeft: `${isTabletOrLower ? marginToCenter : 16}px`,
              paddingRight: `${isTabletOrLower ? marginToCenter : 16}px`,
            }}
          >
            <div className={'flex h-full space-x-4 w-fit'}>
              {values.map((v) => {
                if (filteredOptions && !filteredOptions.includes(v.value))
                  return null;

                return (
                  <div
                    className={'card-slider h-full flex'}
                    key={JSON.stringify(v)}
                  >
                    <div
                      onClick={() => {
                        onChange(value !== v.value ? v.value : undefined);
                      }}
                      style={
                        value === v.value
                          ? {
                              background:
                                v?.color?.hex[0] === '#'
                                  ? `${v?.color?.hex}46`
                                  : v?.color?.hex,
                            }
                          : undefined
                      }
                      className={clsx(
                        'flex',
                        'w-full',
                        'rounded-2xl',
                        'flex-col',
                        'justify-between',
                        'items-center',
                        'px-6 py-8',
                        'cursor-pointer',
                        'hover:opacity-100',
                        'opacity-70',
                        'transition',
                        'duration-200',
                        'border',
                        value === v.value ? 'opacity-100' : 'bg-white'
                      )}
                    >
                      <div className={'flex flex-1 flex-col'}>
                        <div className='flex justify-center'>
                          <div
                            style={{ background: v?.color?.hex }}
                            className={clsx(
                              'md:h-56 md:w-56',
                              'h-36 w-36',
                              'rounded-full'
                            )}
                          >
                            {v?.image && (
                              <Image
                                {...v?.image}
                                className={'rounded-full'}
                                objectFit='cover'
                                height='100%'
                                width='100%'
                              />
                            )}
                            {/*   v?.image */}
                          </div>
                        </div>
                        <div className='mt-6 flex-1'>
                          <Label {...v.label} size='lg' weight='bold' />
                          <Label
                            text={v?.subLabel?.text}
                            size='base'
                            color={{ classname: 'gray-500' }}
                          />
                          <div className={'mt-2'} />
                          <Label {...v.body} size='base' />
                        </div>
                        <div className='mt-4 w-full px-6'>
                          {value !== v.value ? (
                            <Button
                              label={{ text: select?.text || 'Valider' }}
                              fullWidth
                              type='contained'
                              color={{ classname: 'redChristmas' }}
                            />
                          ) : (
                            <Button
                              label={{
                                text: unselect?.text || 'Déselectionner',
                              }}
                              fullWidth
                              type='contained'
                              color={{ classname: 'black' }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {scroll?.x?.percentage > 0.1 ? (
            <div className={`absolute rounded-l-full inset-y-1/2 left-4`}>
              <Button
                onClick={() => handleOnClick('left')}
                type='white'
                size='sm'
                color={{ classname: 'primary' }}
                icon={{
                  iconKey: 'HiChevronLeft',
                  size: 'base',
                }}
              />
            </div>
          ) : null}
          {overflow && scroll?.x?.percentage < 0.9 ? (
            <div className={`absolute rounded-l-full inset-y-1/2 right-4`}>
              <Button
                onClick={() => handleOnClick('right')}
                type='white'
                size='sm'
                color={{ classname: 'primary' }}
                icon={{
                  iconKey: 'HiChevronRight',
                  size: 'base',
                }}
              />
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};
